import { RSAA } from 'redux-api-middleware';
import * as types from "../types/index";
import { API_ENDPOINT, AUTH_HEADERS } from '../../config/ApiConstants';


export function delete_user_Action(token, userId, groupId,organisationId) {
    // var searchbyname = data ? data : "";
    // console.log("data Action--",data);
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/organisation/group/${groupId}/user-delete/${userId}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                'Authorization': `Bearer ${token}`,
                organisationId: organisationId,
                },
            types: [
                types.DELETE_USER_REQUEST,
                types.DELETE_USER_RECEIVE, {
                    type: types.DELETE_USER_FAILURE,
                    meta: (action, state, res) => {
                        return (action, state, res);
                    }
                }]
        }
    }
}

export const resetdelete_user_Action = () => {
    return {
        type: types.RESET_DELETE_USER,
        payload: null
    }
};
